import { Injectable } from "@angular/core";

import { HttpHeaders, HttpRequest } from "@angular/common/http";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { environment } from "../../../environments/environment";
import { APIService } from "./api.service";
import { StorageService } from "./storage.service";
import { AppConfigService } from "./app-config.service";

@Injectable({
  providedIn: "root",
})
export class AuthService {

  baseUrl = AppConfigService.settings?.urls?.apiBaseURL;
  currentUser: any = this.storageService.getUserData();
  error_data: BehaviorSubject<any> = new BehaviorSubject('');



  constructor(private router: Router,
    private storageService: StorageService,
    private apiService: APIService
  ) { }


  isUserDataAvailable() {

    let user = JSON.parse(this.storageService.getUserData());
    if (user != null) {
      return true;
    } else {
      this.storageService.setReturnURL(JSON.stringify(window.location.href));
      this.router.navigate(['/login']);
      return false;
    }
  }


  loginWithSSO() {
    return this.apiService.get('/auth/login/');
  }



  loginWithToken(data: any) {
    return this.apiService.post(`/auth/login/?AuthCode=${data.code}&state=${data.state}`, '');
  }


  logout() {
    // return this.http.get(this.$baseUrl + , this.Options());

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.apiService.get('/auth/logout', httpOptions)
  }


  refreshToken() {
    return this.apiService.get('/auth/refresh/');
  }


   addTokenHeader(request: HttpRequest<any>, token: string, language?: string) {
    let headers: any = {
      Authorization: `Bearer ${token}`,
      'Time-zone': new Date().getTimezoneOffset().toString()
    };
    if (language) {
      headers['Accept-Language'] = language;
    }
    return request.clone({
      setHeaders: headers // This is where the error might be occurring
    });
  }


}
